// extracted by mini-css-extract-plugin
module.exports = {"centeredContent":"styles_centeredContent__2ieRF"};